export default __webpack_public_path__ + "static/media/Apple iPad Air (2019).e6532f16.png";